const e = ["#b8e5e5", "#60b5b6", "#209091", "#023c3d"], c = ["#b8e5e5", "#82c8c8", "#3da2a3", "#037e7e", "#023c3d"], d = [
  "#e4fdfd",
  "#b8e5e5",
  "#82c8c8",
  "#3da2a3",
  "#037e7e",
  "#023c3d"
];
export {
  e as DEMOGRAPHICS_TEAL_4,
  c as DEMOGRAPHICS_TEAL_5,
  d as DEMOGRAPHICS_TEAL_6
};
//# sourceMappingURL=index.es5595.js.map
